import React from 'react';
import DeleteConfirmation from '../DeleteConfirmation/DeleteConfirmation';

/**
 * Valida nome de intenções e entidade de acordo com as regras do watson
 * @param {*} name
 * @param {*} notAllowedNames
 * @return `obj.valid = true` se valido.
 * @return `obj.message` com a mensagem de validação, se `obj.valid = false`
 */
export const validateIntentsAndEntitiesName = (name, notAllowedNames) => {
  if (!/^[\w|_|\-|.]+$/.test(name)) {
    return {
      valid: false,
      message: 'Pode conter apenas caracteres alfanuméricos, sublinhados, hífen e pontos.',
    };
  }
  if (/^sys-/.test(name)) {
    return {
      valid: false,
      message: 'Não pode começar com o prefixo sys-',
    };
  }

  if (notAllowedNames && notAllowedNames.includes(name)) {
    return {
      valid: false,
      message: 'Não pode ter um nome repetido',
    };
  }

  return {
    valid: true,
  };
};

/**
 * Mostra caixa de dialogo para confirmação de remoção
 * @param {*} objectsToDelete estado com exemplos de inteções ou valores de entities para remover
 * @param {*} removeConfirmation função que será chamada na confirmação da remoção
 * @param {*} setObjectsToDelete função para alterar o estado passado em objectsToDelete
 */
export const showRemoveConfirmation = (
  objectsToDelete,
  removeConfirmation,
  setObjectsToDelete,
) => {
  if (objectsToDelete.length > 0) {
    return (
      <DeleteConfirmation
        title="Confirmar exclusão"
        content="Deseja prossseguir com a exclusão?"
        confirmationClick={() => removeConfirmation(objectsToDelete)}
        cancelationClick={() => setObjectsToDelete([])}
      />
    );
  }
  return null;
};

export default null;
